import { useAtom } from 'jotai'
import { Store } from 'lib/models'
import { createAtom } from './atomFactory'
import { MMKVKey } from '../mmkv'

const { atom, resetAtom } = createAtom<Array<Store>>([], MMKVKey.SearchStores)

export const useSearchStores = () => useAtom(atom)
export const useResetSearchStores = () => useAtom(resetAtom)
